import { useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Contents from './Contents/Contents';
import SidebarMenuContainer from './Menu/SidebarMenuContainer';
import TopAppBar from './AppBar/TopAppBar';

/**
 * Primary layout container.  Contains app bar, menu, and page contents.
 * @returns Navigation component
 */
const Navigation = props => {
	const [showFavoritesCustomization, setShowFavoritesCustomization] =
		useState(false);

	const onClickShowFavorites = show => {
		if (typeof show === 'boolean') {
			setShowFavoritesCustomization(show);
		} else {
			setShowFavoritesCustomization(!showFavoritesCustomization);
		}
	};

	const layout = (
		<Box sx={{ display: 'flex', height: window.innerHeight }}>
			<CssBaseline />
			<TopAppBar />
			<SidebarMenuContainer onClickShowFavorites={onClickShowFavorites} />
			<Contents
				showFavorites={showFavoritesCustomization}
				onClickHideFavorites={() => onClickShowFavorites(false)}
			>
				{props.children}
			</Contents>
		</Box>
	);

	return layout;
};

Navigation.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]).isRequired,
};

export default Navigation;
